import script from "./input-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./input-field.vue?vue&type=script&setup=true&lang=ts"

import "./input-field.vue?vue&type=style&index=0&id=2343f332&lang=scss"

const __exports__ = script;

export default __exports__